import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PrintWarehouseLabels.css';

function PrintWarehouseLabels() {
  const navigate = useNavigate();

  const handlePrintLabels = () => navigate('/print-warehouse-labels/print');
  const handleCheckLabelOut = () => navigate('/print-warehouse-labels/check-label-out');
  const handleReprintLabel = () => navigate('/print-warehouse-labels/reprint');

  return (
    <div className="pwl-container">
      <button className="pwl-button" onClick={handlePrintLabels}>
        Print Warehouse Labels
      </button>
      <button className="pwl-button" onClick={handleCheckLabelOut}>
        Check Label In and Out of Warehouse
      </button>
      <button className="pwl-button" onClick={handleReprintLabel}>
        Print Log
      </button>
    </div>
  );
}

export default PrintWarehouseLabels;
